import { render, staticRenderFns } from "./UnsupportTemplate.vue?vue&type=template&id=5a299cf8&scoped=true&"
import script from "./UnsupportTemplate.vue?vue&type=script&lang=js&"
export * from "./UnsupportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportTemplate.vue?vue&type=style&index=0&id=5a299cf8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a299cf8",
  null
  
)

export default component.exports